// Libs
import React from 'react'

// CSS
import "./styles.scss"

const SpCasePageMoreInfoTags = ({
  title,
  options
}) => (
  <div className="my-cases-page-filter-tags">
    <p>{title}</p>
    <div>
      {options.map((option, idx) => (
        <span key={idx}>{option}</span>
      ))}
    </div>
  </div>
)

export default SpCasePageMoreInfoTags
